import { useState } from "react";
import { Dropdown, Form } from "react-bootstrap";

import { FilterPopover, useFilterPopover } from "./filterPopover";

export enum NumberOperators {
	equalTo = "equalTo",
	greaterThan = "greaterThan",
	lessThan = "lessThan",
	// isEmpty = "isEmpty",
}

const filterOptions = [
	{
		value: "equalTo",
		operators: [NumberOperators.equalTo],
		label: "Equal To",
	},
	// { value: "notEquals", label: "Not Equal To" },
	{
		value: "greaterThan",
		operators: [NumberOperators.greaterThan],
		label: "Greater Than",
	},
	{
		value: "greaterThanOrEqual",
		operators: [NumberOperators.greaterThan, NumberOperators.equalTo],
		label: "Greater Than or Equal",
	},
	{
		value: "lessThan",
		operators: [NumberOperators.lessThan],
		label: "Less Than",
	},
	{
		value: "lessThanOrEqual",
		operators: [NumberOperators.lessThan, NumberOperators.equalTo],
		label: "Less Than or Equal",
	},
	{
		value: "between",
		operators: [NumberOperators.greaterThan, NumberOperators.lessThan],
		label: "Between",
		needsTwoInputs: true,
	},
	// {
	// 	value: "isEmpty",
	// 	operators: [NumberOperators.equals],
	// 	label: "Is Empty",
	// 	needsInput: false,
	// },
];

export const NumberColumnFilter = ({
	column: { filterValue, setFilter, defaultFilterValue },
}) => {
	const popover = useFilterPopover();
	const [filterType, setFilterType] = useState("equalTo");
	const [value1, setValue1] = useState("");
	const [value2, setValue2] = useState("");

	const getCurrentFilterLabel = () =>
		filterOptions.find((opt) => opt.value === filterType)?.label ||
		"Select Filter";

	const needsNoInput = () =>
		filterType === "isEmpty" || filterType === "isNotEmpty";

	const needsTwoInputs = () => filterType === "between";

	const handleApply = () => {
		const currentFilter = filterOptions.find(
			(opt) => opt.value === filterType,
		);
		if (!currentFilter) return;

		let filterConfig: Record<string, number> = {};

		// if (currentFilter.needsInput === false) {
		// 	// For isEmpty
		// 	filterConfig[NumberOperators.isEmpty] = null;
		// } else
		if (currentFilter.needsTwoInputs) {
			// For between: { greaterThan: value1, lessThan: value2 }
			if (value1 !== "" && value2 !== "") {
				filterConfig[currentFilter.operators[0]] = parseFloat(value1); // min
				filterConfig[currentFilter.operators[1]] = parseFloat(value2); // max
			} else {
				return;
			}
		} else {
			if (value1 !== "") {
				currentFilter.operators.forEach((op) => {
					filterConfig[op] = parseFloat(value1);
				});
			} else {
				return;
			}
		}

		setFilter?.(filterConfig);
		popover.setHasActiveFilter(true);
		popover.close();
	};

	const handleClear = () => {
		setValue1("");
		setValue2("");
		setFilterType("equalTo");
		setFilter();
		popover.setHasActiveFilter(false);
		popover.close();
	};

	const isApplyDisabled = () => {
		if (needsNoInput()) return false;
		if (needsTwoInputs()) return value1 === "" || value2 === "";
		return value1 === "";
	};

	return (
		<FilterPopover
			popoverId="popover-number-filter"
			applyDisabled={isApplyDisabled()}
			onApply={handleApply}
			onClear={handleClear}
			popoverState={popover}
		>
			<div className="d-flex align-items-center justify-content-between">
				<Form.Label className="fw-bold mb-0">Condition</Form.Label>
				<Dropdown
					style={{
						flex: 1,
						maxWidth: "var(--filter-input-width, 70%)",
					}}
				>
					<Dropdown.Toggle
						size="sm"
						variant="outline-secondary"
						id="filter-type-dropdown"
						className="w-100 d-flex justify-content-between align-items-center"
					>
						<span>{getCurrentFilterLabel()}</span>
						<i className="fas fa-chevron-down ms-2"></i>
					</Dropdown.Toggle>
					<Dropdown.Menu
						className="py-1"
						style={{ width: "100%", minWidth: 0 }}
					>
						{filterOptions.map((option) => (
							<Dropdown.Item
								key={option.value}
								active={filterType === option.value}
								onClick={() => setFilterType(option.value)}
								className="py-1"
								style={{ fontSize: "0.8125rem" }}
							>
								{option.label}
							</Dropdown.Item>
						))}
					</Dropdown.Menu>
				</Dropdown>
			</div>

			{!needsNoInput() && (
				<div className="d-flex align-items-center justify-content-between">
					<Form.Label className="fw-bold mb-0">Value</Form.Label>
					<div
						style={{
							flex: 1,
							maxWidth: "var(--filter-input-width, 70%)",
						}}
					>
						<Form.Control
							size="sm"
							type="number"
							placeholder={
								needsTwoInputs() ? "Min value" : "Enter value"
							}
							value={value1}
							onChange={(e) => setValue1(e.target.value)}
							step="any"
						/>
						{needsTwoInputs() && (
							<Form.Control
								size="sm"
								type="number"
								placeholder="Max value"
								value={value2}
								onChange={(e) => setValue2(e.target.value)}
								step="any"
								className="mt-2"
							/>
						)}
					</div>
				</div>
			)}
		</FilterPopover>
	);
};
